import React, { useState } from 'react';
import DownIcon from 'mdi-react/ChevronDownIcon';
import { Collapse } from 'reactstrap';
import TopbarMenuLink from './TopbarMenuLink';
import { AuthContext } from "../../App/firebaseAuth";
import { useContext } from 'react';

const Ava = `${process.env.PUBLIC_URL}/img/ava.png`;

const TopbarProfile = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const handleToggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };
  const auth = useContext(AuthContext)
  const { currentUser } = auth

  return (
    <div className="topbar__profile">
      <button type="button" className="topbar__avatar" onClick={setIsCollapsed}>
        <img className="topbar__avatar-img" src={currentUser?currentUser.photoURL:Ava} alt="avatar" />
        <p className="topbar__avatar-name">{currentUser && currentUser.displayName}</p>
        <DownIcon className="topbar__icon" />
      </button>
      {isCollapsed && (
        <button
          type="button"
          aria-label="button collapse"
          className="topbar__back"
          onClick={handleToggleCollapse}
        />
      )}
      <Collapse isOpen={isCollapsed} className="topbar__menu-wrap">
        <div className="topbar__menu">
          {/* <TopbarMenuLink title="Page one" icon="list" path="/pages/one" collap={handleToggleCollapse} />
          <TopbarMenuLink title="Page two" icon="inbox" path="/pages/two" collap={handleToggleCollapse} /> */}
          <div className="topbar__menu-divider" />
          <TopbarMenuLink title="ออกจากระบบ" icon="exit" path="/logout" collap={handleToggleCollapse} />
        </div>
      </Collapse>
    </div>
  );
};

export default TopbarProfile;
